// Longest extra guidance an operator can give Cleo when regenerating a draft
// (CL-3213). Shared so the regenerate dialog and the callable agree on it.
export const MAX_REGENERATION_INSTRUCTIONS_LENGTH = 2000
